<img class="divider" src="/img/games/questions/lijnen.svg" width="100%">
